var _line, _path, _path2, _line2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSliderScale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.68122,
    y1: 2.83889,
    x2: 10.7145,
    y2: 1.27327,
    stroke: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.41808 3.13295L1.18072 3.04578L1.3749 2.88381L1.41808 3.13295Z",
    fill: "currentColor",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0606 1.46189L11.2548 1.29992L11.0174 1.21274L11.0606 1.46189Z",
    fill: "currentColor",
    stroke: "currentColor"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.0122071,
    y1: 5.9082,
    x2: 13.0001,
    y2: 5.9082,
    stroke: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.09618 6.02636C4.09618 6.38313 3.80696 6.67235 3.45019 6.67235C3.09342 6.67235 2.8042 6.38313 2.8042 6.02636C2.8042 5.66959 3.09342 5.38037 3.45019 5.38037C3.80696 5.38037 4.09618 5.66959 4.09618 6.02636Z",
    fill: "white",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderScale);
export default __webpack_public_path__ + "static/media/slider-scale.4bc31484f1cdab71ade7a1d4a3b8d6ee.svg";
export { ForwardRef as ReactComponent };